import { Config } from '@backstage/config';

/**
 * Get the Microsoft auth scopes for the Azure Policy plugin.
 * This retrieves the scopes from platt.azurePolicy.authScopes
 * configuration path.
 *
 * @param config - Backstage config object
 * @returns The array of scope strings, or empty array if not configured
 */
export function getMicrosoftAuthScope(config: Config): string[] {
  try {
    const scopes = config.getOptionalStringArray(
      'platt.azurePolicy.authScopes',
    );

    return scopes ?? [];
  } catch (error) {
    // If config path doesn't exist or is malformed, return empty array
    return [];
  }
}
